export default "__VITE_ASSET__CMfeIz0q__"